import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getData = createAsyncThunk('appPermission/getData', async (params) => {
      const response = await axios.post(' https://api.zasway.com:8443/Permissions/GetTableSummary', params, {mode:'cors'})
      return {
         params,
         data: response.data.data,
         allData: response.data.allData,
         totalPages: response.data.total
      }
   })

   export const getRoutePermissions = createAsyncThunk('appPermission/getRoutePermissions', async (params) => {
      const response = await axios.post(' https://api.zasway.com:8443/Permissions/GetTableSummary', params, {mode:'cors'})
      return {
         params,
         data: response.data
      }
   })

   export const getRoutePermissionsEditData = createAsyncThunk('appPermission/getRoutePermissionsEditData', async (params) => {
      const response = await axios.post(' https://api.zasway.com:8443/Permissions/GetTableSummary', params, {mode:'cors'})
      return {
         data: response.data.data
      }
   })

   export const getStaffRole = createAsyncThunk('appPermission/getStaffRole', async () => {
      const response = await axios.post(' https://api.zasway.com:8443/Permissions/GetStaffRoleList')
      return response.data
   })

   export const addAssign = createAsyncThunk('appPermission/addAssign', async (Basic) => {
      const response = await axios.post(' https://api.zasway.com:8443/Permissions/Assign', Basic, {mode:'cors'})
      return response
   })

   export const editAssign = createAsyncThunk('appPermission/editAssign',  async (Permissions) => {
      const response = await axios.post(' https://api.zasway.com:8443/Permissions/Assign', Permissions, {mode:'cors'}) 
      return response
    })
   
export const appPermissionsSlice = createSlice({
   name: 'appPermission',
   initialState: {
      RoutePermissionsData: [],
      routePermissionsEditData: [],
      data: [],
      routePermissionsData: [],
      rpEditData: [],
      total: 1,
      params: {},
      allData: []
   },
   reducers: {},
   extraReducers: builder => {
      builder

      .addCase(getData.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })

      .addCase(getRoutePermissionsEditData.fulfilled, (state, action) => {
        state.routePermissionsEditData = action.payload.data
      })

      .addCase(getRoutePermissions.fulfilled, (state, action) => {
         state.RoutePermissionsData = action.payload.data
      })

      .addCase(editAssign.fulfilled, (state, action) => {
         state.rpEditData = action.payload.data
      })
   }
})

export default appPermissionsSlice.reducer
